function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAscendantLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 720,
    viewBox: "0 0 720 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ascendant-logo"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 21",
    cx: 360,
    cy: 360,
    r: 340,
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_214",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 40,
    width: 641,
    height: 641
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 359.5,
    cy: 360.5,
    r: 320.5,
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_214)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 359.5,
    cy: 360.5,
    r: 320.5,
    fill: "#431436",
    style: {
      fill: "#431436",
      fill: "color(display-p3 0.2627 0.0784 0.2118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 6",
    cx: 359.5,
    cy: 321.377,
    rx: 320.5,
    ry: 305.413,
    fill: "#A4012B",
    style: {
      fill: "#A4012B",
      fill: "color(display-p3 0.6431 0.0039 0.1686)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 12",
    cx: 359.438,
    cy: 283.2,
    rx: 280.438,
    ry: 267.236,
    fill: "#DC3901",
    style: {
      fill: "#DC3901",
      fill: "color(display-p3 0.8627 0.2235 0.0039)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 7",
    cx: 359.375,
    cy: 242.718,
    rx: 240.375,
    ry: 226.754,
    fill: "#FD7601",
    style: {
      fill: "#FD7601",
      fill: "color(display-p3 0.9922 0.4627 0.0039)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 8",
    cx: 359.312,
    cy: 202.655,
    rx: 200.312,
    ry: 186.691,
    fill: "#FDA905",
    style: {
      fill: "#FDA905",
      fill: "color(display-p3 0.9922 0.6627 0.0196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 9",
    cx: 359.25,
    cy: 162.593,
    rx: 160.25,
    ry: 146.629,
    fill: "#FFD301",
    style: {
      fill: "#FFD301",
      fill: "color(display-p3 1.0000 0.8275 0.0039)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 10",
    cx: 359.188,
    cy: 122.53,
    rx: 120.188,
    ry: 106.566,
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 13",
    d: "M379.062 308.018C379.062 319.081 370.094 328.049 359.031 328.049C347.968 328.049 339 319.081 339 308.018C339 296.955 347.968 287.986 359.031 287.986C370.094 287.986 379.062 296.955 379.062 308.018Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 359.044,
    cy: 370.917,
    r: 28.0437,
    fill: "#FFD301",
    style: {
      fill: "#FFD301",
      fill: "color(display-p3 1.0000 0.8275 0.0039)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 359.056,
    cy: 448.637,
    r: 36.0562,
    fill: "#FDA905",
    style: {
      fill: "#FDA905",
      fill: "color(display-p3 0.9922 0.6627 0.0196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 359.069,
    cy: 532.77,
    r: 44.0688,
    fill: "#FD7601",
    style: {
      fill: "#FD7601",
      fill: "color(display-p3 0.9922 0.4627 0.0039)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 359.078,
    cy: 627.922,
    r: 50.0781,
    fill: "#DC3901",
    style: {
      fill: "#DC3901",
      fill: "color(display-p3 0.8627 0.2235 0.0039)",
      fillOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendantLogo);
export default __webpack_public_path__ + "static/media/ascendant-logo.b70e03da7aa96c5e3ee129ed284203e4.svg";
export { ForwardRef as ReactComponent };